<i18n locale="en">
{
  "label": "Pro"
}
</i18n>
<template>
  <span
    :class="['upsell-gate-badge', { 'upsell-gate-badge--dark': dark }]"
    data-testid="upsell-gate-badge"
  >
    <SparkleFilled v-if="!dark" :size="12" />
    {{ text ?? t('label') }}
  </span>
</template>

<script lang="ts" setup>
import { SparkleFilled } from '@owner/icons-vue/SparkleFilled'
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    dark?: boolean
    text?: string
  }>(),
  {
    dark: false,
    text: undefined,
  }
)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.upsell-gate-badge {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14.4px;
  text-transform: uppercase;
  color: #219de0;
  background-color: #e6f1f6;

  &--dark {
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 16.8px;
    color: #dcf2f5;
    background-color: #2c2c2c;
    box-shadow:
      -2px 0 4px rgb(84 152 255 / 25%),
      2px 2px 4px rgb(123 255 138 / 25%),
      inset 0 -1px 2.7px rgb(255 255 255 / 41%);
  }
}
</style>
